import React from "react";

function Header() {
  return (
    <header className="bg-blue-500 w-full py-3 text-white text-center">
      <h1 className="text-left text-center p-4 md:p-0 md:text-center md:text-3xl font-bold">
        piTube
      </h1>
    </header>
  );
}

export default Header;